import React from "react";
import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      sx={{
        marginTop: 4,
        padding: 2,
        backgroundColor: "#f5f5f5",
        textAlign: "center",
      }}
    >
      <Typography variant="body2">© 2025 Datakeet. All Rights Reserved.</Typography>
    </Box>
  );
};

export default Footer;

